import FuzzySet from "fuzzyset.js";

const fs = FuzzySet(JSON.parse(wp.searchSuggestions.replace(/\n|\r/g, "")));

const search = document.querySelector(".navbarSearch");
const input = search.querySelector("input[type=search]");
const autoComplete = search.querySelector(".autocomplete > div");

const headerSearch = document.querySelector(".header .search");

document.querySelector(".search-toggle").addEventListener("click", event => {
  event.preventDefault();
  if (headerSearch.classList.contains("active")) {
    closeSearch();
  } else {
    openSearch();
  }
});

function openSearch() {
  search.classList.add("active");
  document.body.classList.add("search-active");
}

function closeSearch() {
  search.classList.remove("active");
  document.body.classList.remove("search-active");
}

document.addEventListener("click", e => {
  if (
    !e.target.closest(".navbarSearch") &&
    !e.target.closest(".search-toggle")
  ) {
    closeSearch();
  }
});

input.addEventListener("keyup", e => {
  handleAutoComplete(e.target.value);
});

input.addEventListener("onblur", e => {
  handleAutoComplete();
});

document.addEventListener("click", e => {
  const result = e.target.closest(".autocomplete span");
  if (!result) return;
  input.value = result.dataset.value;

  window.location = `${wp.url}?s=${result.dataset.value}`;
});

const handleAutoComplete = v => {
  const value = v || input.value;
  if (value.length > 1) {
    const results = fs.get(value);

    if (results && results.length > 0) {
      search.classList.add("autoCompleted");
      autoComplete.innerHTML = "";

      results.forEach((result, index) => {
        if (index > 6) return;
        autoComplete.insertAdjacentHTML(
          "beforeend",
          `<span data-value="${result[1]}">${result[1]}</span>`
        );
      });
    } else {
      search.classList.remove("autoCompleted");
      autoComplete.innerHTML = "";
    }
  } else {
    search.classList.remove("autoCompleted");
    autoComplete.innerHTML = "";
  }
};
